import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function IconTemperature(props) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
        <path d="M647 499.1C706.2 543.8 745 614.1 745 694C745 829.3 635.3 939 500 939C364.7 939 255 829.3 255 694C255 614.1 293.8 543.9 353 499.1L353 210C353 128.8 418.9 63 500 63C581.2 63 647 128.8 647 210L647 499.1ZM598 210C598 155.9 554.1 112 500 112C445.9 112 402 155.9 402 210L402 525.7C343.7 559.5 304 621.7 304 694C304 802.2 391.8 890 500 890C608.2 890 696 802.2 696 694C696 621.7 656.3 559.5 598 525.7L598 210Z" />
        <path d="M353 697C353 778.2 418.8 844 500 844C581.2 844 647 778.2 647 697C647 615.8 581.2 550 500 550C418.8 550 353 615.8 353 697Z" />
        <path d="M452 339L547.3 339L547.3 596L452 596L452 339Z" />
      </svg>
    </SvgIcon>
  );
}
